import React from 'react';
import { motion } from 'framer-motion';


const LocationMap = () => {
  const address = process.env.REACT_APP_ADDRESS;
  const googleMapsApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
  
//   // Debug logging
//   console.log('API Key from env:', googleMapsApiKey);
//   console.log('API Key length:', googleMapsApiKey?.length);
//   console.log('API Key exists:', !!googleMapsApiKey);
  
  // Check if API key is available
  if (!googleMapsApiKey) {
    console.warn('Google Maps API key not found. Please check your .env file.');
  }
  
  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      className="w-full"
    >
      <div className="w-full h-auto bg-gradient-to-r from-[#1e2024] to-[#23272b] p-8 rounded-lg shadow-shadowOne">
        <div className="flex flex-col gap-4 mb-6">
          <h3 className="text-2xl font-bold text-lightText">
            🌏 Location
          </h3>
          <p className="text-base text-gray-400 leading-6">
            Currently based in Columbia Falls, MT, US
          </p>
          <div className="flex flex-col gap-2">
            <span className="text-designColor font-medium">Address:</span>
            <p className="text-lightText">{address}</p>
          </div>
        </div>
        
        <div className="w-full h-80 rounded-lg overflow-hidden border border-gray-600">
          {googleMapsApiKey ? (
            <iframe
              src={`https://www.google.com/maps/embed/v1/place?key=${googleMapsApiKey}&q=${encodeURIComponent(address)}&zoom=15&maptype=roadmap`}
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Location Map - Columbia Falls, MT, US"
            />
          ) : (
            <div className="w-full h-full bg-gray-800 flex items-center justify-center">
              <div className="text-center">
                <p className="text-lightText text-lg mb-2">🗾 Japan Location</p>
                <p className="text-gray-400 text-sm">{address}</p>
                <p className="text-gray-500 text-xs mt-2">Google Maps API key required for interactive map</p>
              </div>
            </div>
          )}
        </div>
        <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="bg-[#0c1821] p-4 rounded-lg">
            <h4 className="text-lg font-semibold text-designColor mb-2">Availability</h4>
            <p className="text-gray-300 text-sm">Available for remote work worldwide</p>
            <p className="text-gray-300 text-sm">Available in any timezone to match your needs</p>
          </div>
          <div className="bg-[#0c1821] p-4 rounded-lg">
            <h4 className="text-lg font-semibold text-designColor mb-2">Timezone</h4>
            <p className="text-gray-300 text-sm">🕐 MST/MDT (GMT-7)</p>
          </div>
        </div>
        
        <div className="mt-6">
          <h4 className="text-lg font-semibold text-designColor mb-3">Work Preferences</h4>
          <div className="flex flex-wrap gap-2">
            <span className="px-3 py-1 bg-designColor bg-opacity-20 text-designColor rounded-full text-sm">Remote</span>
            <span className="px-3 py-1 bg-designColor bg-opacity-20 text-designColor rounded-full text-sm">Freelance/Contract</span>
            <span className="px-3 py-1 bg-designColor bg-opacity-20 text-designColor rounded-full text-sm">Full-time</span>
            <span className="px-3 py-1 bg-designColor bg-opacity-20 text-designColor rounded-full text-sm">Part-time</span>
          </div>
        </div>
{/*         
        <div className="mt-4 text-sm text-gray-400">
          <p>🌍 Columbia Falls, MT, US</p>
          <p>🕐 MST/MDT (GMT-6)</p>
        </div> */}
      </div>
    </motion.div>
  );
};

export default LocationMap;